import {
    FETCH_MTOKNA_CODES,
    CLEAN_MTOKNA_CODES,
    DELETE_MTOKNA_CODE,
    CHANGE_MTOKNA_CODE,
} from '../actions/types';
import _ from "lodash";
import {toNumber} from "../functions";

const MTOKNA_CODES_DEFAULT_STATE = {};

const MtoknaCodesReducer = (state = MTOKNA_CODES_DEFAULT_STATE, { type, payload }) => {
    switch (type) {
        case FETCH_MTOKNA_CODES:
            return payload;

        case CHANGE_MTOKNA_CODE:
            return { ...state, items: _.map(state.items, item => {
                if (toNumber(item.id) === toNumber(payload.id)) {
                    item = { ...item, code: payload.code, sku: payload.sku };
                }

                return item;
            }) };

        case CLEAN_MTOKNA_CODES:
        case DELETE_MTOKNA_CODE:
            return MTOKNA_CODES_DEFAULT_STATE;

        default:
            return state;
    }
};

export default MtoknaCodesReducer;
